import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	items: [],
};

const crateSlice = createSlice({
	name: "crate",
	initialState,
	reducers: {
		addToCrate(state, action) {
			const item = action.payload;
			const exists = state.items.find(i => i.id === item.id);
			if (exists) {
				return;
			}
			if (state.items.length >= 12) {
				action.meta = { showToast: true };
				return;
			}
			state.items.push(item);
		},
		removeFromCrate(state, action) {
			const id = action.payload;
			state.items = state.items.filter(item => item.id !== id);
		},
		clearCrate(state) {
			state.items = [];
		},
		setCrateItems(state, action) {
			state.items = action.payload || [];
		},
	},
});



export const { addToCrate, removeFromCrate, clearCrate, setCrateItems, } = crateSlice.actions;
export default crateSlice.reducer;
